exports.onClientEntry = async () => {
  // NodeList.forEach (needed to use document.querySelectorAll)
  // @see https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
};
